import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames, UitkContextWrapper } from 'uitk-react-utils';
import styles from './uitk-checkbox.css';

var getClassNameList = classNames.bind(styles);
var UitkCheckbox = /** @class */ (function (_super) {
    __extends(UitkCheckbox, _super);
    function UitkCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.useReducedMotion = false;
        _this.state = {
            checked: props.checked
        };
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    UitkCheckbox.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.checked !== prevState.checked) {
            return {
                checked: nextProps.checked
            };
        }
        return null;
    };
    UitkCheckbox.prototype.componentDidMount = function () {
        // On mount set mediaQuery to check if user has reduced motion enabled
        this.useReducedMotion =
            typeof window.matchMedia === 'function' && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    };
    UitkCheckbox.prototype.handleChange = function (e) {
        var onChange = this.props.onChange;
        var checked = this.state.checked;
        this.setState({ checked: !checked });
        if (onChange) {
            onChange(e);
        }
    };
    UitkCheckbox.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, className = _b.className, children = _b.children, description = _b.description, disabled = _b.disabled, errorMessage = _b.errorMessage, id = _b.id, indeterminate = _b.indeterminate, labelClassName = _b.labelClassName, labelSuffix = _b.labelSuffix, name = _b.name, required = _b.required, value = _b.value, defaultChecked = _b.defaultChecked, a11yLabel = _b.a11yLabel, domRef = _b.domRef;
        var checked = this.state.checked;
        if (checked && defaultChecked) {
            console.error('Both checked and defaultChecked prop can`t be set it as true');
        }
        var checkedProp = defaultChecked ? 'defaultChecked' : 'checked';
        var checkedVal = defaultChecked || checked;
        var baseCssClass = 'uitk-checkbox';
        var wrapperClassNames = getClassNameList(baseCssClass, {
            'is-disabled': disabled
        });
        var labelCssClassNames = getClassNameList("uitk-checkbox-label", (_a = {},
            _a[labelClassName] = Boolean(labelClassName),
            _a['uitk-checkbox-label-haslabelsuffix'] = labelSuffix,
            _a['is-required'] = required,
            _a));
        var inputClassNames = getClassNameList({
            checked: checked
        });
        var iconClassNames = getClassNameList('uitk-checkbox-icon');
        var controlClassNames = getClassNameList("".concat(baseCssClass, "-control"));
        var contentClassNames = getClassNameList("".concat(baseCssClass, "-content"));
        var labelContentClassNames = getClassNameList("".concat(baseCssClass, "-label-content"));
        var labelSuffixClassNames = getClassNameList("".concat(baseCssClass, "-label-suffix"));
        var descriptionClassNames = getClassNameList("".concat(baseCssClass, "-description uitk-type-200"));
        var errorClassNames = getClassNameList("".concat(baseCssClass, "-error"));
        var controlAndReducedMotionClassNames = [
            controlClassNames,
            getClassNameList("".concat(baseCssClass, "-has-reduced-motion"))
        ];
        var contents = children;
        // Forces screen reader to pause when reading a label with multiple parts
        var ariaLabel = a11yLabel || [contents, labelSuffix, description].filter(function (elem) { return !!elem; }).toString();
        return (React.createElement(UitkContextWrapper, null, function (context, data) {
            var _a;
            return (React.createElement(UitkLayoutFlex, { className: wrapperClassNames, wrap: "nowrap" },
                React.createElement(UitkLayoutFlexItem, { shrink: 0, className: className },
                    React.createElement("input", __assign({ type: "checkbox", name: name || id, id: id }, (_a = {}, _a[checkedProp] = checkedVal, _a), { className: inputClassNames, disabled: disabled, onChange: _this.handleChange, value: value, ref: domRef, "aria-describedby": errorMessage ? "".concat(id, "-error") : undefined, "aria-invalid": errorMessage ? true : undefined, "aria-required": required, "aria-checked": indeterminate ? 'mixed' : undefined, "aria-label": ariaLabel }))),
                React.createElement(UitkLayoutFlexItem, { className: _this.useReducedMotion ? controlAndReducedMotionClassNames : controlClassNames, shrink: 0 },
                    React.createElement("span", { "aria-hidden": "true" }, checkedVal && React.createElement(UitkIcon, { name: indeterminate ? 'remove' : 'check', className: iconClassNames }))),
                React.createElement(UitkLayoutFlexItem, { className: contentClassNames, grow: 1 },
                    React.createElement("div", null,
                        React.createElement("label", { className: labelCssClassNames, htmlFor: id },
                            React.createElement("p", { className: labelContentClassNames },
                                contents,
                                required && (data === null || data === void 0 ? void 0 : data.hasRequiredFieldIndicator) && (React.createElement("span", { className: "uitk-checkbox-required-asterisk", "aria-hidden": "true" },
                                    ' ',
                                    "*"))),
                            labelSuffix && React.createElement("p", { className: labelSuffixClassNames }, labelSuffix),
                            description && React.createElement("p", { className: descriptionClassNames }, description)),
                        errorMessage && (React.createElement("p", { className: errorClassNames, id: "".concat(id, "-error") }, errorMessage))))));
        }));
    };
    UitkCheckbox.displayName = 'UitkCheckbox';
    UitkCheckbox.defaultProps = {
        checked: false
    };
    return UitkCheckbox;
}(React.Component));

export { UitkCheckbox };
